import { entityStore } from '~/utility/BinSentry-ui-utility';
import { LitEntity, SirenActionMixin, html, css, renderIf } from '../utility/lit-entity';
import { sharedStyles } from '../styles/shared-styles';
import '../common/bn-flash';
import '../common/bn-action';
import './tag-list-item';

class TagList extends SirenActionMixin(LitEntity) {
  constructor() {
    super();
    this.tags = [];
    this.key = '';
    this.value = '';
  }

  static get properties() {
    return {
      addTagAction: { type: Object },
      tags: { type: Array },
      key: { typye: String },
      value: { typye: String },
    };
  }

  static get styles() {
    return [sharedStyles, css`
      .actions {
        display: flex;
      }
      table {
        width: 100%;
      }
    `];
  }

  render() {
    const tagsHaveActions = this.entity?.hasAction('add-tag') || this.entity?.entities?.some(e => e.actions?.length > 0);
    return html`
      <div class="tags">
        <form @submit="${this._submit}">
          <bn-flash></bn-flash>
          <table>
            <thead>
              <tr>
                <th>Key</th>
                <th>Value</th>
                ${renderIf(tagsHaveActions, html`<th></th>`)}
              </tr>
            </thead>
            <tbody>
              ${this.tags.map((tag) => html`
                <tag-list-item
                  .href="${tag.getLinkByRel('self').href}"
                  @response="${this._tagActionSuccess}"
                  @save="${this._onTagSave}"
                  @error="${this._tagActionError}"
                  @submit="${this._onTagEdit}"
                ></tag-list-item>
              `)}
            </tbody>
            ${renderIf(this.entity?.hasAction('add-tag'), () => html`
              <tfoot>
                <tr class="add-tag">
                  <td>
                    <input type="text" id="tag-name" name="tag-name" .value="${this.key}" @input="${(e) => this.key = e.target.value}"/>
                  </td>
                  <td>
                    <input type="text" id="tag-value" name="tag-value" .value="${this.value}" @input="${(e) => this.value = e.target.value}"/>
                  </td>
                  <td>
                    <div class="actions">
                      <button
                        type="submit"
                        class="button button--outlined"
                        ?disabled="${!this.value || !this.key}"
                      >
                        Save
                      </button>
                    </div>
                  </td>
                </tr>
              </tfoot>
            `)}
          </table>
        </form>
      </div>
    `;
  }

  update(props) {
    if (props.has('href')) {
      this._clear();
    }
    super.update();
  }

  _entityChanged(entity) {
    super._entityChanged(entity);
    if (!this.entity) {
      return;
    }
    this.tags = (this.entity && this.entity.entities) || [];
    this.addTagAction = this.entity.getActionByName('add-tag');
  }

  async _clear() {
    const flash = this.shadowRoot.querySelector('bn-flash');
    flash && flash.clear();
  }

  async _error(msg) {
    this.shadowRoot.querySelector('bn-flash').critical(msg);
  }

  async _success(msg) {
    this.shadowRoot.querySelector('bn-flash').success(msg);
  }

  _tagActionError(error) {
    this._clear();
    this._error(error.message);
  }

  _tagActionSuccess() {
    this._clear();
    this._success('Tag has been deleted');
    entityStore.invalidateHref(this.href);
  }

  _onTagSave() {
    this._clear();
    this._success('Tag has been updated');
    entityStore.invalidateHref(this.href);
  }

  async _submit(e) {
    e.preventDefault();
    const { key, value } = this;

    this._clear();
    const action = this.addTagAction;
    if (!action) {
      this._error('Could not find [add-tag] action');
      return;
    }
    const fields = this.getActionFields(action);
    fields.set('key', key);
    fields.set('value', value);
    try {
      const { error } = await this.submitAction(action, fields);
      if (error) {
        this._error(error);
      } else {
        this._success('Tag has been saved');
        this.key = '';
        this.value = '';
        entityStore.invalidateHref(this.href);
      }
    } catch (err) {
      this._error('Could not save tag.');
    }
  }
}

window.customElements.define('tag-list', TagList);
